export const PRODUCT_LIMIT_FREE = 100;
export const PRODUCT_LIMIT_STARTER = 1000000;
export const PRODUCT_LIMIT_PROFESSIONAL = 15000000;